const ug_programs = [
  {
    id: "1",
    program: "Civil engineering",
    intake: "60",
    year:"1952"
  },
  {
    id: "2",
    program: "Mechanical Engineering",
    intake: "120",
    year:"1952"
  },
  {
    id: "3",
    program: "Electrical and Electronics Engineering",
    intake: "120",
    year:"1952"
  },
  {
    id: "4",
    program: "Electronics and Communication Engineering",
    intake: "60",
    year:"1968"
  },
  {
    id: "5",
    program: "Computer Science and Engineering",
    intake: "60",
    year:"2001"
  },
  {
    id:"6",
    program:"Information Technology",
    intake:"60",
    year:"2025"
  }
];

const pg_programs = [
  {
    id: "1",
    program: "Structural Engineering ",
    intake: "18",
  },
  {
    id: "2",
    program: "Environmental Engineering",
    intake: "18",
  },
  {
    id: "3",
    program: "Manufacturing Engineering",
    intake: "18",
  },
  {
    id: "4",
    program: "Computer Aided Design",
    intake: "18",
  },
  {
    id: "5",
    program: "Power Electronics and Drives",
    intake: "18",
  },
  {
    id: "6",
    program: "Microwave andOptical Communication",
    intake: "18",
  },
];

const pt_programs = [
  {
    id: "1",
    program: "Civil engineering",
    intake: "60",
  },
  {
    id: "2",
    program: "Mechanical Engineering",
    intake: "60",
  },
  {
    id: "3",
    program: "Electrical and Electronics Engineering",
    intake: "60",
  },
  {
    id: "4",
    program: "Electronics and Communication Engineering",
    intake: "60",
  },
];

export { ug_programs, pg_programs, pt_programs };
